import ApiService from "@/core/services/api.service";
import ProductConfigurationService from "@/core/services/product-configuration.service.js";

const isDuplicateNavigation = error =>
  error &&
  (error.name === "NavigationDuplicated" ||
    String(error.message || "").includes("Avoided redundant navigation"));

const BranchNavigationService = {
  async activate(branchId, verticalCodes = [], router = null, verticalSkin = null) {
    const id = String(branchId);

    localStorage.setItem("medhop_branch_id", id);
    if (id === "all") {
      localStorage.removeItem("medhop_branch_vertical_codes");
      localStorage.removeItem("medhop_branch_vertical_skin");
    } else {
      localStorage.setItem(
        "medhop_branch_vertical_codes",
        JSON.stringify(verticalCodes || [])
      );
      if (verticalSkin) localStorage.setItem("medhop_branch_vertical_skin", verticalSkin);
      else localStorage.removeItem("medhop_branch_vertical_skin");
    }
    ApiService.setBranchHeader(id);

    // Refresh configuration while the new branch header is already active so
    // the dashboard and sidebar never reuse the previous branch's cache.
    try {
      await ProductConfigurationService.refresh();
    } catch (_) {
      // Layout will retry after reload; backend branch guards remain authoritative.
    }

    if (router && router.currentRoute && router.currentRoute.name !== "dashboard") {
      try {
        await router.replace({ name: "dashboard" });
      } catch (error) {
        if (!isDuplicateNavigation(error)) throw error;
      }
    }

    window.location.reload();
  },
};

export default BranchNavigationService;
